<template >
  <div class="support" :style="{ 'min-height': clientHeight + 'px' }">
    <div class="support-header">
      <div class="header-content">
        <h2 class="title">
          <router-link
            to="/en/support"
            class="link"
            v-if="$t('m.lang') == 'en'"
            >{{ $t("m.sedNav.supportTitle") }}</router-link
          >
          <router-link
            to="/support-zh/"
            class="link"
            v-if="$t('m.lang') == 'zh'"
            >{{ $t("m.sedNav.supportTitle") }}</router-link
          >
          <span class="support-text-addon">
            <span class="arrow">&gt;</span>
            <span class="support-current-breadcrumb">{{
              $t("m.sedNav.content")
            }}</span>
          </span>
        </h2>
        <div class="search">
          <span class="support-input">
            <input
              type="text"
              class="support-ipt"
              :placeholder="$t('m.sedNav.search')"
              v-model="searchinpt"
              @keydown.enter="search()"
          /></span>
          <span class="search-icon"> </span>
        </div>
      </div>
    </div>
    <div class="support-content" v-if="!load" @click="show_element($event)">
      <article class="support-main">
        <section class="support-list">
          <h3 class="support-title support-detail-title">
            {{ detail.title }}
          </h3>
          <div class="support-detail">
            <p class="paragraph" v-html="detail.content"></p>
            <Help :like="like" :title="title" :dislike="dislike"></Help>
          </div>
        </section>
      </article>

      <FreqWithBtn></FreqWithBtn>
    </div>
    <div class="loading" v-if="load" :style="{ 'min-height': '2007px' }"></div>
    <div class="openImg" v-if="amp" @click="amp = false">
      <img :src="ampSrc" alt="" srcset="" />
    </div>
  </div>
</template>

<script>
import i18n from "../lang";
import { useRoute, useRouter } from "vue-router";
import FreqWithBtn from "../components/FreqWithBtn.vue";
import Help from "../components/Help.vue";
import axios from "axios";
export default {
  components: { FreqWithBtn, Help },
  setup() {
    return {
      contentTitle: useRouter().currentRoute.value.query.title,
    };
  },
  data() {
    return {
      //可视区域高度
      clientHeight: "",
      searchinpt: "",
      content: [],
      Freq: [],
      tital: "",
      detail: "",
      load: true,
      amp: false,
      ampSrc: "",
      like: "",
      dislike: "",
      lang: "",
      title:""
    };
  },
   watch: {
    $route(to, from) {
      this.$router.go(0);
    },
  },
  mounted() {
    // 获取浏览器可视区域高度
    var obj = useRoute().params.title;
    if (/.*[\u4e00-\u9fa5]+.*$/.test(obj)) {
      axios({
        url: "https://64qx6jnt0a.execute-api.cn-north-1.amazonaws.com.cn/Prod/",
        method: "POST",
        data: {
          methods: "getLangkeys",
          title: useRoute().params.title,
        },
      }).then((result) => {
        this.$router.push(
          "/support-zh/" +
            result.data.Items[0].langkeys
              .replaceAll(` `, `-`)
              .replaceAll(`/`, `&`) +
            "/"
        );
      });
    } else {
      axios({
        url: "https://64qx6jnt0a.execute-api.cn-north-1.amazonaws.com.cn/Prod/",
        method: "POST",
        data: {
          methods: "getSupArticleNew",
          langkeys: useRoute()
            .params.title.replaceAll(`-`, ` `)
            .replaceAll(`&`, `/`),
          lang: "zh",
        },
      }).then((res) => {
        console.log(res.data.Items[0].title);
        this.title = res.data.Items[0].title
        this.load = false;
        this.detail = res.data.Items[0];
        this.lang = this.detail.lang;
        this.like = this.detail.like;
        this.dislike = this.detail.dislike ? this.detail.dislike : 0;
        i18n.global.locale = this.lang;
        this.$route.hash = this.detail.langkeys;
        var reg = new RegExp(`target="_blank"`, "g");
        this.detail.content = this.detail.content.replace(reg, "");
        this.detail.content = this.detail.content.replaceAll(
          "/contentweb-zh?title=",
          "/support-zh/"
        );
        this.detail.content = this.detail.content.replaceAll(
          "/contentweb?title=",
          "/support-zh/"
        );
        this.detail.content = this.detail.content.replaceAll(
          "/submit-a-ticket",
          "/submit-a-ticket-zh"
        );
      });
    }

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.clientHeight = `${document.documentElement.clientHeight}` - 104; //document.body.clientWidth;
    zE("webWidget", "hide");
  },
  methods: {
    show_element(e) {
      if (!e) {
        var e = window.event;
      }
      //获取事件点击元素
      var targ = e.target;
      //获取元素名称
      var tname = targ.tagName;
      if (this.contentTitle == "Oculus Touch 手柄按键" && tname == "IMG") {
        this.ampSrc = targ.src;
        this.amp = true;
      }
    },

    search() {
      if (this.$i18n.t("m.lang") == "en") {
        this.$router.push({
          path: "/search",
          query: { search: this.searchinpt },
        });
      } else {
        this.$router.push({
          path: "/search-zh",
          query: { search: this.searchinpt },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
//部分样式与support公用
@import "../assets/scss/content.scss";
</style>